// extracted by mini-css-extract-plugin
export default {"body":"nnKtT31wbnrs0u6ByPa9"};